// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.mt-wrapper {
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e7eaec;
  overflow: hidden;
}

.mt-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e7eaec;
}
.mt-header__title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.mt-header__heading {
  margin: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #6d6e71;
}
.mt-header__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgb(105, 190, 40);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 12px;
  line-height: 1.4;
}

.mt-alert {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  background: #fff8e1;
  border-bottom: 1px solid #ffe082;
  font-size: 13px;
  color: #676a6c;
}
.mt-alert__icon {
  color: #f5a623;
  font-size: 16px;
  flex-shrink: 0;
}
.mt-alert__text {
  flex: 1;
  font-weight: 600;
}
.mt-alert__close {
  cursor: pointer;
  color: #6d6e71;
  font-size: 14px;
  flex-shrink: 0;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}
.mt-alert__close:hover {
  opacity: 1;
}

.mt-search {
  padding: 12px 20px;
  border-bottom: 1px solid #e7eaec;
  background: #f1f1f2;
}
.mt-search__inner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 0 12px;
  transition: border-color 0.2s ease;
}
.mt-search__inner:focus-within {
  border-color: rgb(0, 173, 208);
}
.mt-search__icon {
  color: #6d6e71;
  font-size: 14px;
  flex-shrink: 0;
  opacity: 0.5;
}
.mt-search__input {
  flex: 1;
  border: none;
  outline: none;
  padding: 8px 4px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: transparent;
  min-width: 0;
}
.mt-search__input::placeholder {
  color: #ccc;
}
.mt-search__input + .mt-search__input {
  border-left: 1px solid #e7eaec;
  padding-left: 12px;
}

.mt-table-wrap {
  overflow-x: auto;
}
@media only screen and (max-width: 991px) {
  .mt-table-wrap {
    display: none;
  }
}

.mt-table {
  width: 100%;
  border-collapse: collapse;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.mt-table__th {
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #6d6e71;
  background: #f1f1f2;
  padding: 10px 14px;
  border-bottom: 2px solid #e7eaec;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}
.mt-table__th--sortable {
  cursor: pointer;
  transition: background 0.15s ease;
}
.mt-table__th--sortable:hover {
  background: #e9e9eb;
}
.mt-table__th--sortable .fa {
  margin-left: 6px;
  font-size: 12px;
  opacity: 0.5;
}
.mt-table__row {
  transition: background 0.15s ease;
  border-bottom: 1px solid #e7eaec;
}
.mt-table__row:hover {
  background: rgba(241, 241, 242, 0.6);
}
.mt-table__row.f-d-none {
  display: none !important;
}
.mt-table__td {
  padding: 10px 14px;
  font-size: 13px;
  color: #676a6c;
  vertical-align: middle;
}
.mt-table__td--empty {
  text-align: center;
  font-weight: 700;
  padding: 20px;
}
.mt-table__name {
  font-weight: 600;
  color: #676a6c;
}
.mt-table__no-profile {
  font-size: 12px;
  color: #ccc;
  font-style: italic;
}

.mt-advice-btn {
  display: inline-block;
  border: 1.5px solid rgb(105, 190, 40);
  color: rgb(105, 190, 40);
  border-radius: 14px;
  padding: 4px 14px;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.2s ease;
}
.mt-advice-btn:hover {
  background: rgb(105, 190, 40);
  color: #fff;
  text-decoration: none;
}

.mt-role-badge {
  display: inline-block;
  background: #6d6e71;
  color: #fff;
  border-radius: 3px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
}

.mt-contact {
  display: flex;
  align-items: center;
  gap: 6px;
}
.mt-contact__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: #676a6c;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.2s ease;
}
.mt-contact__icon:hover {
  background: #f1f1f2;
  color: rgb(105, 190, 40);
  text-decoration: none;
}

.mt-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #e7eaec;
  background: #f1f1f2;
}
.mt-footer__perpage {
  display: flex;
  align-items: center;
  gap: 8px;
}
.mt-footer__label {
  font-size: 12px;
  color: #676a6c;
  margin: 0;
  white-space: nowrap;
}
.mt-footer__select {
  padding: 4px 8px;
  font-size: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #676a6c;
  outline: none;
  cursor: pointer;
}
.mt-footer__select:focus {
  border-color: rgb(0, 173, 208);
}
.mt-footer__pages {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
}
.mt-footer__page {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  border: 1px solid #6d6e71;
  font-size: 12px;
  font-weight: 600;
  color: #6d6e71;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}
.mt-footer__page:hover {
  opacity: 0.8;
}
.mt-footer__page--active {
  background: #6d6e71;
  color: #fff;
}

.mt-mobile {
  display: none;
  padding: 10px 16px;
}
@media only screen and (max-width: 991px) {
  .mt-mobile {
    display: block;
  }
}
.mt-mobile__card {
  border: 1px solid #e7eaec;
  border-radius: 6px;
  margin-bottom: 12px;
  background: #fff;
  overflow: hidden;
}
.mt-mobile__card.f-d-none {
  display: none !important;
}
.mt-mobile__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid #e7eaec;
}
.mt-mobile__name {
  display: flex;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #676a6c;
}
.mt-mobile__profile {
  display: flex;
  align-items: center;
  gap: 8px;
}
.mt-mobile__bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
}
@media only screen and (max-width: 991px) {
  .mt-footer {
    flex-direction: column;
    gap: 12px;
    align-items: flex-end;
  }
  .mt-footer__perpage {
    width: 100%;
    justify-content: flex-end;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/teams/myteams-teammates-table/myteams-teammates-table.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA1YA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AA6YF;;AAvYA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AA0YF;AAxYE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA0YJ;AAvYE;EACE,SAAA;EACA,wED7BS;EC8BT,eAAA;EACA,gBAAA;EACA,cDQiB;ACiYrB;AAtYE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BDhBY;ECiBZ,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAwYJ;;AAjYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,cDzBmB;AC6ZrB;AAlYE;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAoYJ;AAjYE;EACE,OAAA;EACA,gBAAA;AAmYJ;AAhYE;EACE,eAAA;EACA,cDnCiB;ECoCjB,eAAA;EACA,cAAA;EACA,YAAA;EACA,6BAAA;AAkYJ;AAhYI;EACE,UAAA;AAkYN;;AA1XA;EACE,kBAAA;EACA,gCAAA;EACA,mBDlDoB;AC+atB;AA3XE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AA6XJ;AA3XI;EACE,8BDrFU;ACkdhB;AAzXE;EACE,cDvEiB;ECwEjB,eAAA;EACA,cAAA;EACA,YAAA;AA2XJ;AAxXE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,wED3HS;EC4HT,cDzFiB;EC0FjB,uBAAA;EACA,YAAA;AA0XJ;AAxXI;EACE,WDvFc;ACidpB;AAvXI;EACE,8BAAA;EACA,kBAAA;AAyXN;;AAjXA;EACE,gBAAA;AAoXF;AAlXE;EAHF;IAII,aAAA;EAqXF;AACF;;AAlXA;EACE,WAAA;EACA,yBAAA;EACA,wEDzJW;AC8gBb;AAnXE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cDxHiB;ECyHjB,mBDtHkB;ECuHlB,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AAqXJ;AAnXI;EACE,eAAA;EACA,iCAAA;AAqXN;AAnXM;EACE,mBAAA;AAqXR;AAlXM;EACE,gBAAA;EACA,eAAA;EACA,YAAA;AAoXR;AA/WE;EACE,iCAAA;EACA,gCAAA;AAiXJ;AA/WI;EACE,oCAAA;AAiXN;AA9WI;EACE,wBAAA;AAgXN;AA5WE;EACE,kBAAA;EACA,eAAA;EACA,cDpKiB;ECqKjB,sBAAA;AA8WJ;AA5WI;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;AA8WN;AA1WE;EACE,gBAAA;EACA,cDhLiB;AC4hBrB;AAzWE;EACE,eAAA;EACA,WD9KgB;EC+KhB,kBAAA;AA2WJ;;AApWA;EACE,qBAAA;EACA,qCAAA;EACA,wBD5Mc;EC6Md,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDxOW;ECyOX,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;AAuWF;AArWE;EACE,6BDxNY;ECyNZ,WAAA;EACA,qBAAA;AAuWJ;;AAhWA;EACE,qBAAA;EACA,mBDlNmB;ECmNnB,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAmWF;;AA7VA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAgWF;AA9VE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cD/OiB;ECgPjB,eAAA;EACA,qBAAA;EACA,yBAAA;AAgWJ;AA9VI;EACE,mBD7OgB;EC8OhB,wBDlQU;ECmQV,qBAAA;AAgWN;;AAxVA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBD7PoB;ACwlBtB;AAzVE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA2VJ;AAxVE;EACE,eAAA;EACA,cD/QiB;ECgRjB,SAAA;EACA,mBAAA;AA0VJ;AAvVE;EACE,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cD1RiB;EC2RjB,aAAA;EACA,eAAA;AAyVJ;AAvVI;EACE,8BD7SU;ACsoBhB;AArVE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AAuVJ;AApVE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cD/SiB;ECgTjB,eAAA;EACA,yBAAA;EACA,yBAAA;UAAA,iBAAA;AAsVJ;AApVI;EACE,YAAA;AAsVN;AAnVI;EACE,mBDzTe;EC0Tf,WAAA;AAqVN;;AA7UA;EACE,aAAA;EACA,kBAAA;AAgVF;AA9UE;EAJF;IAKI,cAAA;EAiVF;AACF;AA/UE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAiVJ;AA/UI;EACE,wBAAA;AAiVN;AA7UE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AA+UJ;AA5UE;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cDxWiB;ACsrBrB;AA3UE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA6UJ;AA1UE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AA4UJ;AAjUA;EACE;IACE,sBAAA;IACA,SAAA;IACA,qBAAA;EAmUF;EAjUE;IACE,WAAA;IACA,yBAAA;EAmUJ;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n// ─────────────────────────────────────────\n// Wrapper\n// ─────────────────────────────────────────\n.mt-wrapper {\n  background: #fff;\n  border-radius: 6px;\n  border: 1px solid $color-grey-1;\n  overflow: hidden;\n}\n\n// ─────────────────────────────────────────\n// Header\n// ─────────────────────────────────────────\n.mt-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid $color-grey-1;\n\n  &__title {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  &__heading {\n    margin: 0;\n    font-family: $font-stack;\n    font-size: 16px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n  }\n\n  &__badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: $develop-color;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 10px;\n    border-radius: 12px;\n    line-height: 1.4;\n  }\n}\n\n// ─────────────────────────────────────────\n// Alert banner\n// ─────────────────────────────────────────\n.mt-alert {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 20px;\n  background: #fff8e1;\n  border-bottom: 1px solid #ffe082;\n  font-size: 13px;\n  color: $body-content-color;\n\n  &__icon {\n    color: #f5a623;\n    font-size: 16px;\n    flex-shrink: 0;\n  }\n\n  &__text {\n    flex: 1;\n    font-weight: 600;\n  }\n\n  &__close {\n    cursor: pointer;\n    color: $color-neutral-dark;\n    font-size: 14px;\n    flex-shrink: 0;\n    opacity: 0.6;\n    transition: opacity 0.2s ease;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n// ─────────────────────────────────────────\n// Search bar\n// ─────────────────────────────────────────\n.mt-search {\n  padding: 12px 20px;\n  border-bottom: 1px solid $color-grey-1;\n  background: $color-neutral-light;\n\n  &__inner {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: #fff;\n    border: 1px solid $color-neutral-mid;\n    border-radius: 6px;\n    padding: 0 12px;\n    transition: border-color 0.2s ease;\n\n    &:focus-within {\n      border-color: $clarify-color;\n    }\n  }\n\n  &__icon {\n    color: $color-neutral-dark;\n    font-size: 14px;\n    flex-shrink: 0;\n    opacity: 0.5;\n  }\n\n  &__input {\n    flex: 1;\n    border: none;\n    outline: none;\n    padding: 8px 4px;\n    font-size: 13px;\n    font-family: $font-stack;\n    color: $body-content-color;\n    background: transparent;\n    min-width: 0;\n\n    &::placeholder {\n      color: $color-neutral-mid;\n    }\n\n    & + & {\n      border-left: 1px solid $color-grey-1;\n      padding-left: 12px;\n    }\n  }\n}\n\n// ─────────────────────────────────────────\n// Table\n// ─────────────────────────────────────────\n.mt-table-wrap {\n  overflow-x: auto;\n\n  @media #{$tablet} {\n    display: none;\n  }\n}\n\n.mt-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: $font-stack;\n\n  &__th {\n    text-transform: uppercase;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    color: $color-neutral-dark;\n    background: $color-neutral-light;\n    padding: 10px 14px;\n    border-bottom: 2px solid $color-grey-1;\n    white-space: nowrap;\n    user-select: none;\n\n    &--sortable {\n      cursor: pointer;\n      transition: background 0.15s ease;\n\n      &:hover {\n        background: darken($color-neutral-light, 3%);\n      }\n\n      .fa {\n        margin-left: 6px;\n        font-size: 12px;\n        opacity: 0.5;\n      }\n    }\n  }\n\n  &__row {\n    transition: background 0.15s ease;\n    border-bottom: 1px solid $color-grey-1;\n\n    &:hover {\n      background: rgba($color-neutral-light, 0.6);\n    }\n\n    &.f-d-none {\n      display: none !important;\n    }\n  }\n\n  &__td {\n    padding: 10px 14px;\n    font-size: 13px;\n    color: $body-content-color;\n    vertical-align: middle;\n\n    &--empty {\n      text-align: center;\n      font-weight: 700;\n      padding: 20px;\n    }\n  }\n\n  &__name {\n    font-weight: 600;\n    color: $body-content-color;\n  }\n\n  &__no-profile {\n    font-size: 12px;\n    color: $color-neutral-mid;\n    font-style: italic;\n  }\n}\n\n// ─────────────────────────────────────────\n// 1:1 Advice pill button\n// ─────────────────────────────────────────\n.mt-advice-btn {\n  display: inline-block;\n  border: 1.5px solid $develop-color;\n  color: $develop-color;\n  border-radius: 14px;\n  padding: 4px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: $font-stack;\n  cursor: pointer;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: $develop-color;\n    color: #fff;\n    text-decoration: none;\n  }\n}\n\n// ─────────────────────────────────────────\n// Role badge\n// ─────────────────────────────────────────\n.mt-role-badge {\n  display: inline-block;\n  background: $color-neutral-dark;\n  color: #fff;\n  border-radius: 3px;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.4;\n}\n\n// ─────────────────────────────────────────\n// Contact icons\n// ─────────────────────────────────────────\n.mt-contact {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  &__icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    color: $body-content-color;\n    font-size: 14px;\n    text-decoration: none;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: $color-neutral-light;\n      color: $develop-color;\n      text-decoration: none;\n    }\n  }\n}\n\n// ─────────────────────────────────────────\n// Pagination footer\n// ─────────────────────────────────────────\n.mt-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  border-top: 1px solid $color-grey-1;\n  background: $color-neutral-light;\n\n  &__perpage {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__label {\n    font-size: 12px;\n    color: $body-content-color;\n    margin: 0;\n    white-space: nowrap;\n  }\n\n  &__select {\n    padding: 4px 8px;\n    font-size: 12px;\n    border: 1px solid $color-neutral-mid;\n    border-radius: 4px;\n    background: #fff;\n    color: $body-content-color;\n    outline: none;\n    cursor: pointer;\n\n    &:focus {\n      border-color: $clarify-color;\n    }\n  }\n\n  &__pages {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 5px;\n  }\n\n  &__page {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    border-radius: 4px;\n    border: 1px solid $color-neutral-dark;\n    font-size: 12px;\n    font-weight: 600;\n    color: $color-neutral-dark;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    user-select: none;\n\n    &:hover {\n      opacity: 0.8;\n    }\n\n    &--active {\n      background: $color-neutral-dark;\n      color: #fff;\n    }\n  }\n}\n\n// ─────────────────────────────────────────\n// Mobile card view\n// ─────────────────────────────────────────\n.mt-mobile {\n  display: none;\n  padding: 10px 16px;\n\n  @media #{$tablet} {\n    display: block;\n  }\n\n  &__card {\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    margin-bottom: 12px;\n    background: #fff;\n    overflow: hidden;\n\n    &.f-d-none {\n      display: none !important;\n    }\n  }\n\n  &__top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 14px;\n    border-bottom: 1px solid $color-grey-1;\n  }\n\n  &__name {\n    display: flex;\n    gap: 6px;\n    font-size: 13px;\n    font-weight: 700;\n    color: $body-content-color;\n  }\n\n  &__profile {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__bottom {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 14px;\n  }\n\n  &__role {\n    // placeholder for role badge\n  }\n}\n\n// ─────────────────────────────────────────\n// Tablet responsive adjustments\n// ─────────────────────────────────────────\n@media #{$tablet} {\n  .mt-footer {\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-end;\n\n    &__perpage {\n      width: 100%;\n      justify-content: flex-end;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
